import "./App.css";

import Login from "./component/Login";
import Dashboard from "./component/Dashboard";
function App() {
  return (
    <>
      <Login />
      <Dashboard />
    </>
  );
}

export default App;
